import * as React from "react";
import View from "views/logic/views/View";
import useViewType from "views/hooks/useViewType";
const IfSearch = ({ children }) => {
  const viewType = useViewType();
  return viewType === View.Type.Search ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : null;
};
export default IfSearch;
